
import Swiper from 'swiper';
export default class SectionDates {
    

    static get selector() {
      return '.sectionDates';
    }
    
    constructor(el) {
        this.el = el;
        this.slider = el.querySelector('.sectionDates__slider');
        this.prev = el.querySelector('.sectionDates__prev');
        this.next = el.querySelector('.sectionDates__next');


        this.swiper = new Swiper(this.slider, {
            autoplay: {
                delay: 200
            },
            slidesPerView: 1,
            loop: true,
 
        });
        
        this.setEvents();
    }

    setEvents() {
        this.prev.addEventListener('click', this.e_clickPrev.bind(this));
        this.next.addEventListener('click', this.e_clickNext.bind(this));
    }

    e_clickPrev(e) {
        e.preventDefault();
        this.swiper.slidePrev();
    }
   
    e_clickNext(e) {
        e.preventDefault();
        this.swiper.slideNext();
    }
   
}
